// Generated automatically by nearley, version 2.13.0
// http://github.com/Hardmath123/nearley
(function () {
  function id(x) {
    return x[0]
  }

  var grammar = (isSymbol) => ({
    Lexer: undefined,
    ParserRules: [
      {'name': 'unsigned_int$ebnf$1', 'symbols': [/[0-9]/]},
      {'name': 'unsigned_int$ebnf$1', 'symbols': ['unsigned_int$ebnf$1', /[0-9]/], 'postprocess': function arrpush(d) {
        return d[0].concat([d[1]])
      }},
      {'name': 'unsigned_int', 'symbols': ['unsigned_int$ebnf$1'], 'postprocess':
        function(d) {
          return parseInt(d[0].join(''))
        }
      },
      {'name': 'int$ebnf$1$subexpression$1', 'symbols': [{'literal':'-'}]},
      {'name': 'int$ebnf$1$subexpression$1', 'symbols': [{'literal':'+'}]},
      {'name': 'int$ebnf$1', 'symbols': ['int$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'int$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'int$ebnf$2', 'symbols': [/[0-9]/]},
      {'name': 'int$ebnf$2', 'symbols': ['int$ebnf$2', /[0-9]/], 'postprocess': function arrpush(d) {
        return d[0].concat([d[1]])
      }},
      {'name': 'int', 'symbols': ['int$ebnf$1', 'int$ebnf$2'], 'postprocess':
        function(d) {
          if (d[0]) {
            return parseInt(d[0][0]+d[1].join(''))
          } else {
            return parseInt(d[1].join(''))
          }
        }
      },
      {'name': 'unsigned_decimal$ebnf$1', 'symbols': [/[0-9]/]},
      {'name': 'unsigned_decimal$ebnf$1', 'symbols': ['unsigned_decimal$ebnf$1', /[0-9]/], 'postprocess': function arrpush(d) {
        return d[0].concat([d[1]])
      }},
      {'name': 'unsigned_decimal$ebnf$2$subexpression$1$ebnf$1', 'symbols': [/[0-9]/]},
      {'name': 'unsigned_decimal$ebnf$2$subexpression$1$ebnf$1', 'symbols': ['unsigned_decimal$ebnf$2$subexpression$1$ebnf$1', /[0-9]/], 'postprocess': function arrpush(d) {
        return d[0].concat([d[1]])
      }},
      {'name': 'unsigned_decimal$ebnf$2$subexpression$1', 'symbols': [{'literal':'.'}, 'unsigned_decimal$ebnf$2$subexpression$1$ebnf$1']},
      {'name': 'unsigned_decimal$ebnf$2', 'symbols': ['unsigned_decimal$ebnf$2$subexpression$1'], 'postprocess': id},
      {'name': 'unsigned_decimal$ebnf$2', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'unsigned_decimal', 'symbols': ['unsigned_decimal$ebnf$1', 'unsigned_decimal$ebnf$2'], 'postprocess':
        function(d) {
          return parseFloat(
            d[0].join('') +
                (d[1] ? '.'+d[1][1].join('') : '')
          )
        }
      },
      {'name': 'decimal$ebnf$1', 'symbols': [{'literal':'-'}], 'postprocess': id},
      {'name': 'decimal$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'decimal$ebnf$2', 'symbols': [/[0-9]/]},
      {'name': 'decimal$ebnf$2', 'symbols': ['decimal$ebnf$2', /[0-9]/], 'postprocess': function arrpush(d) {
        return d[0].concat([d[1]])
      }},
      {'name': 'decimal$ebnf$3$subexpression$1$ebnf$1', 'symbols': [/[0-9]/]},
      {'name': 'decimal$ebnf$3$subexpression$1$ebnf$1', 'symbols': ['decimal$ebnf$3$subexpression$1$ebnf$1', /[0-9]/], 'postprocess': function arrpush(d) {
        return d[0].concat([d[1]])
      }},
      {'name': 'decimal$ebnf$3$subexpression$1', 'symbols': [{'literal':'.'}, 'decimal$ebnf$3$subexpression$1$ebnf$1']},
      {'name': 'decimal$ebnf$3', 'symbols': ['decimal$ebnf$3$subexpression$1'], 'postprocess': id},
      {'name': 'decimal$ebnf$3', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'decimal', 'symbols': ['decimal$ebnf$1', 'decimal$ebnf$2', 'decimal$ebnf$3'], 'postprocess':
        function(d) {
          return parseFloat(
            (d[0] || '') +
                d[1].join('') +
                (d[2] ? '.'+d[2][1].join('') : '')
          )
        }
      },
      {'name': 'percentage', 'symbols': ['decimal', {'literal':'%'}], 'postprocess':
        function(d) {
          return d[0]/100
        }
      },
      {'name': 'jsonfloat$ebnf$1', 'symbols': [{'literal':'-'}], 'postprocess': id},
      {'name': 'jsonfloat$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'jsonfloat$ebnf$2', 'symbols': [/[0-9]/]},
      {'name': 'jsonfloat$ebnf$2', 'symbols': ['jsonfloat$ebnf$2', /[0-9]/], 'postprocess': function arrpush(d) {
        return d[0].concat([d[1]])
      }},
      {'name': 'jsonfloat$ebnf$3$subexpression$1$ebnf$1', 'symbols': [/[0-9]/]},
      {'name': 'jsonfloat$ebnf$3$subexpression$1$ebnf$1', 'symbols': ['jsonfloat$ebnf$3$subexpression$1$ebnf$1', /[0-9]/], 'postprocess': function arrpush(d) {
        return d[0].concat([d[1]])
      }},
      {'name': 'jsonfloat$ebnf$3$subexpression$1', 'symbols': [{'literal':'.'}, 'jsonfloat$ebnf$3$subexpression$1$ebnf$1']},
      {'name': 'jsonfloat$ebnf$3', 'symbols': ['jsonfloat$ebnf$3$subexpression$1'], 'postprocess': id},
      {'name': 'jsonfloat$ebnf$3', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'jsonfloat$ebnf$4$subexpression$1$ebnf$1', 'symbols': [/[+-]/], 'postprocess': id},
      {'name': 'jsonfloat$ebnf$4$subexpression$1$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'jsonfloat$ebnf$4$subexpression$1$ebnf$2', 'symbols': [/[0-9]/]},
      {'name': 'jsonfloat$ebnf$4$subexpression$1$ebnf$2', 'symbols': ['jsonfloat$ebnf$4$subexpression$1$ebnf$2', /[0-9]/], 'postprocess': function arrpush(d) {
        return d[0].concat([d[1]])
      }},
      {'name': 'jsonfloat$ebnf$4$subexpression$1', 'symbols': [/[eE]/, 'jsonfloat$ebnf$4$subexpression$1$ebnf$1', 'jsonfloat$ebnf$4$subexpression$1$ebnf$2']},
      {'name': 'jsonfloat$ebnf$4', 'symbols': ['jsonfloat$ebnf$4$subexpression$1'], 'postprocess': id},
      {'name': 'jsonfloat$ebnf$4', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'jsonfloat', 'symbols': ['jsonfloat$ebnf$1', 'jsonfloat$ebnf$2', 'jsonfloat$ebnf$3', 'jsonfloat$ebnf$4'], 'postprocess':
        function(d) {
          return parseFloat(
            (d[0] || '') +
                d[1].join('') +
                (d[2] ? '.'+d[2][1].join('') : '') +
                (d[3] ? 'e' + (d[3][1] || '+') + d[3][2].join('') : '')
          )
        }
      },
      {'name': 'grammar', 'symbols': ['_', 'logical_expr', '_'], 'postprocess':
        function(data) {
          return {
            kind: 'grammar',
            data: data
          }
        }
      },
      {'name': 'logical_expr', 'symbols': ['logical_expr', '__', 'logical_operator', '__', 'comparison_expr']},
      {'name': 'logical_expr', 'symbols': ['comparison_expr'], 'postprocess':
        function(data) {
          return {
            kind: 'logical_expr',
            data: data
          }
        }
      },
      {'name': 'comparison_expr', 'symbols': ['comparison_operand', '_', 'comparison_operator', '_', 'comparison_operand']},
      {'name': 'comparison_expr', 'symbols': ['comparison_operand', '_', 'percentage_comparison', '_', 'percentage_with_empty_parts']},
      {'name': 'comparison_expr', 'symbols': [{'literal':'('}, 'logical_expr', {'literal':')'}], 'postprocess':
        function(data) {
          return {
            kind: 'comparison_expr',
            data: data
          }
        }
      },
      {'name': 'logical_operator$string$1', 'symbols': [{'literal':'a'}, {'literal':'n'}, {'literal':'d'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'logical_operator', 'symbols': ['logical_operator$string$1']},
      {'name': 'logical_operator$string$2', 'symbols': [{'literal':'o'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'logical_operator', 'symbols': ['logical_operator$string$2'], 'postprocess':
        function(data) {
          return {
            kind: 'logical_operator',
            data: data
          }
        }
      },
      {'name': 'comparison_operand', 'symbols': ['math_expr'], 'postprocess':
        function(data) {
          return {
            kind: 'comparison_operand',
            data: data
          }
        }
      },
      {'name': 'comparison_operator', 'symbols': ['greater_than']},
      {'name': 'comparison_operator', 'symbols': ['less_than']},
      {'name': 'comparison_operator', 'symbols': ['equals']},
      {'name': 'comparison_operator', 'symbols': ['cross_up']},
      {'name': 'comparison_operator', 'symbols': ['cross_down']},
      {'name': 'comparison_operator', 'symbols': ['percentage_down']},
      {'name': 'comparison_operator', 'symbols': ['percentage_up'], 'postprocess':
        function(data) {
          return {
            kind: 'comparison_operator',
            data: data
          }
        }
      },
      {'name': 'math_expr', 'symbols': ['addition_expr'], 'postprocess':
        function(data) {
          return {
            kind: 'math_expr',
            data: data
          }
        }
      },
      {'name': 'addition_expr', 'symbols': ['addition_expr', '_', 'addition_operator', '_', 'multiplication_expr']},
      {'name': 'addition_expr', 'symbols': ['multiplication_expr'], 'postprocess':
        function(data) {
          return {
            kind: 'addition_expr',
            data: data
          }
        }
      },
      {'name': 'addition_operator', 'symbols': [{'literal':'+'}]},
      {'name': 'addition_operator', 'symbols': [{'literal':'-'}], 'postprocess':
        function(data) {
          return {
            kind: 'addition_operator',
            data: data
          }
        }
      },
      {'name': 'multiplication_expr', 'symbols': ['multiplication_expr', '_', 'multiplication_operator', '_', 'value']},
      {'name': 'multiplication_expr', 'symbols': ['value'], 'postprocess':
        function(data) {
          return {
            kind: 'multiplication_expr',
            data: data
          }
        }
      },
      {'name': 'multiplication_operator', 'symbols': [{'literal':'*'}]},
      {'name': 'multiplication_operator', 'symbols': ['__', {'literal':'x'}, '__']},
      {'name': 'multiplication_operator', 'symbols': ['__', {'literal':'X'}, '__']},
      {'name': 'multiplication_operator', 'symbols': [{'literal':'/'}], 'postprocess':
        function(data) {
          return {
            kind: 'multiplication_operator',
            data: data
          }
        }
      },
      {'name': 'value', 'symbols': [{'literal':'('}, '_', 'math_expr', '_', {'literal':')'}]},
      {'name': 'value', 'symbols': ['indicator']},
      {'name': 'value', 'symbols': ['microeconomic']},
      {'name': 'value', 'symbols': ['alternative']},
      {'name': 'value', 'symbols': ['number'], 'postprocess':
        function(data) {
          return {
            kind: 'value',
            data: data
          }
        }
      },
      {'name': 'percentage_comparison', 'symbols': ['percentage_down']},
      {'name': 'percentage_comparison', 'symbols': ['percentage_up'], 'postprocess':
        function(data) {
          return {
            kind: 'percentage_comparison',
            data: data
          }
        }
      },
      {'name': 'percentage_down$ebnf$1$subexpression$1', 'symbols': ['synonyms_of_is', '__']},
      {'name': 'percentage_down$ebnf$1', 'symbols': ['percentage_down$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'percentage_down$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'percentage_down$subexpression$1$string$1', 'symbols': [{'literal':'d'}, {'literal':'r'}, {'literal':'o'}, {'literal':'p'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'percentage_down$subexpression$1$ebnf$1', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'percentage_down$subexpression$1$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'percentage_down$subexpression$1', 'symbols': ['percentage_down$subexpression$1$string$1', 'percentage_down$subexpression$1$ebnf$1']},
      {'name': 'percentage_down$subexpression$1$string$2', 'symbols': [{'literal':'d'}, {'literal':'e'}, {'literal':'c'}, {'literal':'l'}, {'literal':'i'}, {'literal':'n'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'percentage_down$subexpression$1$ebnf$2', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'percentage_down$subexpression$1$ebnf$2', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'percentage_down$subexpression$1', 'symbols': ['percentage_down$subexpression$1$string$2', 'percentage_down$subexpression$1$ebnf$2']},
      {'name': 'percentage_down$subexpression$1$string$3', 'symbols': [{'literal':'d'}, {'literal':'o'}, {'literal':'w'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'percentage_down$subexpression$1', 'symbols': ['percentage_down$subexpression$1$string$3']},
      {'name': 'percentage_down', 'symbols': ['percentage_down$ebnf$1', 'percentage_down$subexpression$1'], 'postprocess':
        function(data) {
          return {
            kind: 'percentage_down',
            data: data
          }
        }
      },
      {'name': 'percentage_up$ebnf$1$subexpression$1', 'symbols': ['synonyms_of_is', '__']},
      {'name': 'percentage_up$ebnf$1', 'symbols': ['percentage_up$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'percentage_up$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'percentage_up$subexpression$1$string$1', 'symbols': [{'literal':'r'}, {'literal':'i'}, {'literal':'s'}, {'literal':'e'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'percentage_up$subexpression$1$ebnf$1', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'percentage_up$subexpression$1$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'percentage_up$subexpression$1', 'symbols': ['percentage_up$subexpression$1$string$1', 'percentage_up$subexpression$1$ebnf$1']},
      {'name': 'percentage_up$subexpression$1$string$2', 'symbols': [{'literal':'u'}, {'literal':'p'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'percentage_up$subexpression$1', 'symbols': ['percentage_up$subexpression$1$string$2']},
      {'name': 'percentage_up', 'symbols': ['percentage_up$ebnf$1', 'percentage_up$subexpression$1'], 'postprocess':
        function(data) {
          return {
            kind: 'percentage_up',
            data: data
          }
        }
      },
      {'name': 'microeconomic$ebnf$1$subexpression$1', 'symbols': ['ticker', '__']},
      {'name': 'microeconomic$ebnf$1', 'symbols': ['microeconomic$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'microeconomic$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'microeconomic$ebnf$2$subexpression$1', 'symbols': ['days_back', '__']},
      {'name': 'microeconomic$ebnf$2', 'symbols': ['microeconomic$ebnf$2$subexpression$1'], 'postprocess': id},
      {'name': 'microeconomic$ebnf$2', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'microeconomic', 'symbols': ['microeconomic$ebnf$1', 'microeconomic$ebnf$2', 'microeconomic_tag'], 'postprocess':
        function(data) {
          return {
            kind: 'microeconomic',
            data: data
          }
        }
      },
      {'name': 'microeconomic_tag$string$1', 'symbols': [{'literal':'5'}, {'literal':'2'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$2', 'symbols': [{'literal':'w'}, {'literal':'e'}, {'literal':'e'}, {'literal':'k'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$3', 'symbols': [{'literal':'h'}, {'literal':'i'}, {'literal':'g'}, {'literal':'h'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$1', '_', 'microeconomic_tag$string$2', '__', 'microeconomic_tag$string$3']},
      {'name': 'microeconomic_tag$string$4', 'symbols': [{'literal':'5'}, {'literal':'2'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$5', 'symbols': [{'literal':'w'}, {'literal':'e'}, {'literal':'e'}, {'literal':'k'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$6', 'symbols': [{'literal':'l'}, {'literal':'o'}, {'literal':'w'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$4', '_', 'microeconomic_tag$string$5', '__', 'microeconomic_tag$string$6']},
      {'name': 'microeconomic_tag$string$7', 'symbols': [{'literal':'r'}, {'literal':'e'}, {'literal':'v'}, {'literal':'e'}, {'literal':'n'}, {'literal':'u'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$8', 'symbols': [{'literal':'g'}, {'literal':'r'}, {'literal':'o'}, {'literal':'w'}, {'literal':'t'}, {'literal':'h'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$7', '__', 'microeconomic_tag$string$8']},
      {'name': 'microeconomic_tag$string$9', 'symbols': [{'literal':'e'}, {'literal':'p'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$10', 'symbols': [{'literal':'g'}, {'literal':'r'}, {'literal':'o'}, {'literal':'w'}, {'literal':'t'}, {'literal':'h'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$9', '__', 'microeconomic_tag$string$10']},
      {'name': 'microeconomic_tag$string$11', 'symbols': [{'literal':'e'}, {'literal':'b'}, {'literal':'i'}, {'literal':'t'}, {'literal':'d'}, {'literal':'a'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$12', 'symbols': [{'literal':'g'}, {'literal':'r'}, {'literal':'o'}, {'literal':'w'}, {'literal':'t'}, {'literal':'h'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$11', '__', 'microeconomic_tag$string$12']},
      {'name': 'microeconomic_tag$string$13', 'symbols': [{'literal':'s'}, {'literal':'h'}, {'literal':'o'}, {'literal':'r'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$14', 'symbols': [{'literal':'i'}, {'literal':'n'}, {'literal':'t'}, {'literal':'e'}, {'literal':'r'}, {'literal':'e'}, {'literal':'s'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$13', '__', 'microeconomic_tag$string$14']},
      {'name': 'microeconomic_tag$string$15', 'symbols': [{'literal':'n'}, {'literal':'e'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$16', 'symbols': [{'literal':'d'}, {'literal':'e'}, {'literal':'b'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$17', 'symbols': [{'literal':'t'}, {'literal':'o'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$18', 'symbols': [{'literal':'e'}, {'literal':'b'}, {'literal':'i'}, {'literal':'t'}, {'literal':'d'}, {'literal':'a'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$15', '__', 'microeconomic_tag$string$16', '__', 'microeconomic_tag$string$17', '__', 'microeconomic_tag$string$18']},
      {'name': 'microeconomic_tag$string$19', 'symbols': [{'literal':'p'}, {'literal':'r'}, {'literal':'i'}, {'literal':'c'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$20', 'symbols': [{'literal':'t'}, {'literal':'o'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$21', 'symbols': [{'literal':'b'}, {'literal':'o'}, {'literal':'o'}, {'literal':'k'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$22', 'symbols': [{'literal':'v'}, {'literal':'a'}, {'literal':'l'}, {'literal':'u'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$19', '__', 'microeconomic_tag$string$20', '__', 'microeconomic_tag$string$21', '__', 'microeconomic_tag$string$22']},
      {'name': 'microeconomic_tag$string$23', 'symbols': [{'literal':'p'}, {'literal':'r'}, {'literal':'i'}, {'literal':'c'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$24', 'symbols': [{'literal':'t'}, {'literal':'o'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$25', 'symbols': [{'literal':'e'}, {'literal':'a'}, {'literal':'r'}, {'literal':'n'}, {'literal':'i'}, {'literal':'n'}, {'literal':'g'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$23', '__', 'microeconomic_tag$string$24', '__', 'microeconomic_tag$string$25']},
      {'name': 'microeconomic_tag$string$26', 'symbols': [{'literal':'p'}, {'literal':'r'}, {'literal':'i'}, {'literal':'c'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$27', 'symbols': [{'literal':'t'}, {'literal':'o'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$28', 'symbols': [{'literal':'n'}, {'literal':'e'}, {'literal':'x'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$29', 'symbols': [{'literal':'y'}, {'literal':'e'}, {'literal':'a'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$30', 'symbols': [{'literal':'f'}, {'literal':'o'}, {'literal':'r'}, {'literal':'e'}, {'literal':'c'}, {'literal':'a'}, {'literal':'s'}, {'literal':'t'}, {'literal':'e'}, {'literal':'d'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$31', 'symbols': [{'literal':'e'}, {'literal':'a'}, {'literal':'r'}, {'literal':'n'}, {'literal':'i'}, {'literal':'n'}, {'literal':'g'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$26', '__', 'microeconomic_tag$string$27', '__', 'microeconomic_tag$string$28', '__', 'microeconomic_tag$string$29', '__', 'microeconomic_tag$string$30', '__', 'microeconomic_tag$string$31']},
      {'name': 'microeconomic_tag$string$32', 'symbols': [{'literal':'d'}, {'literal':'i'}, {'literal':'v'}, {'literal':'i'}, {'literal':'d'}, {'literal':'e'}, {'literal':'n'}, {'literal':'d'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$33', 'symbols': [{'literal':'y'}, {'literal':'i'}, {'literal':'e'}, {'literal':'l'}, {'literal':'d'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$32', '__', 'microeconomic_tag$string$33']},
      {'name': 'microeconomic_tag$string$34', 'symbols': [{'literal':'l'}, {'literal':'e'}, {'literal':'v'}, {'literal':'e'}, {'literal':'r'}, {'literal':'a'}, {'literal':'g'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$35', 'symbols': [{'literal':'r'}, {'literal':'a'}, {'literal':'t'}, {'literal':'i'}, {'literal':'o'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$34', '__', 'microeconomic_tag$string$35']},
      {'name': 'microeconomic_tag$string$36', 'symbols': [{'literal':'p'}, {'literal':'r'}, {'literal':'i'}, {'literal':'c'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$37', 'symbols': [{'literal':'t'}, {'literal':'o'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$38', 'symbols': [{'literal':'r'}, {'literal':'e'}, {'literal':'v'}, {'literal':'e'}, {'literal':'n'}, {'literal':'u'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$36', '__', 'microeconomic_tag$string$37', '__', 'microeconomic_tag$string$38']},
      {'name': 'microeconomic_tag$string$39', 'symbols': [{'literal':'i'}, {'literal':'m'}, {'literal':'p'}, {'literal':'l'}, {'literal':'i'}, {'literal':'e'}, {'literal':'d'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$40', 'symbols': [{'literal':'v'}, {'literal':'o'}, {'literal':'l'}, {'literal':'a'}, {'literal':'t'}, {'literal':'i'}, {'literal':'l'}, {'literal':'i'}, {'literal':'t'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$39', '__', 'microeconomic_tag$string$40']},
      {'name': 'microeconomic_tag$string$41', 'symbols': [{'literal':'o'}, {'literal':'p'}, {'literal':'e'}, {'literal':'r'}, {'literal':'a'}, {'literal':'t'}, {'literal':'i'}, {'literal':'n'}, {'literal':'g'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$42', 'symbols': [{'literal':'m'}, {'literal':'a'}, {'literal':'r'}, {'literal':'g'}, {'literal':'i'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$41', '__', 'microeconomic_tag$string$42']},
      {'name': 'microeconomic_tag$string$43', 'symbols': [{'literal':'a'}, {'literal':'v'}, {'literal':'e'}, {'literal':'r'}, {'literal':'a'}, {'literal':'g'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$44', 'symbols': [{'literal':'d'}, {'literal':'a'}, {'literal':'i'}, {'literal':'l'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$45', 'symbols': [{'literal':'v'}, {'literal':'o'}, {'literal':'l'}, {'literal':'u'}, {'literal':'m'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$43', '__', 'microeconomic_tag$string$44', '__', 'microeconomic_tag$string$45']},
      {'name': 'microeconomic_tag$string$46', 'symbols': [{'literal':'f'}, {'literal':'o'}, {'literal':'r'}, {'literal':'w'}, {'literal':'a'}, {'literal':'r'}, {'literal':'d'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$47', 'symbols': [{'literal':'d'}, {'literal':'i'}, {'literal':'v'}, {'literal':'i'}, {'literal':'d'}, {'literal':'e'}, {'literal':'n'}, {'literal':'d'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$48', 'symbols': [{'literal':'r'}, {'literal':'a'}, {'literal':'t'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$46', '__', 'microeconomic_tag$string$47', '__', 'microeconomic_tag$string$48']},
      {'name': 'microeconomic_tag$string$49', 'symbols': [{'literal':'b'}, {'literal':'o'}, {'literal':'o'}, {'literal':'k'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$50', 'symbols': [{'literal':'v'}, {'literal':'a'}, {'literal':'l'}, {'literal':'u'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$51', 'symbols': [{'literal':'p'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$52', 'symbols': [{'literal':'s'}, {'literal':'h'}, {'literal':'a'}, {'literal':'r'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$49', '__', 'microeconomic_tag$string$50', '__', 'microeconomic_tag$string$51', '__', 'microeconomic_tag$string$52']},
      {'name': 'microeconomic_tag$string$53', 'symbols': [{'literal':'b'}, {'literal':'a'}, {'literal':'s'}, {'literal':'i'}, {'literal':'c'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$54', 'symbols': [{'literal':'e'}, {'literal':'a'}, {'literal':'r'}, {'literal':'n'}, {'literal':'i'}, {'literal':'n'}, {'literal':'g'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$55', 'symbols': [{'literal':'p'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag$string$56', 'symbols': [{'literal':'s'}, {'literal':'h'}, {'literal':'a'}, {'literal':'r'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'microeconomic_tag', 'symbols': ['microeconomic_tag$string$53', '__', 'microeconomic_tag$string$54', '__', 'microeconomic_tag$string$55', '__', 'microeconomic_tag$string$56']},
      {'name': 'alternative', 'symbols': ['pct_devices_alternative']},
      {'name': 'alternative', 'symbols': ['sentiment_alternative'], 'postprocess':
        function(data) {
          return {
            kind: 'alternative',
            data: data
          }
        }
      },
      {'name': 'sentiment_alternative', 'symbols': ['ticker_algong_with_days_back', 'sentiment_alternative_tag']},
      {'name': 'sentiment_alternative_tag$string$1', 'symbols': [{'literal':'s'}, {'literal':'e'}, {'literal':'n'}, {'literal':'t'}, {'literal':'i'}, {'literal':'m'}, {'literal':'e'}, {'literal':'n'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'sentiment_alternative_tag', 'symbols': ['sentiment_alternative_tag$string$1']},
      {'name': 'sentiment_alternative_tag$string$2', 'symbols': [{'literal':'s'}, {'literal':'e'}, {'literal':'n'}, {'literal':'t'}, {'literal':'i'}, {'literal':'m'}, {'literal':'e'}, {'literal':'n'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'sentiment_alternative_tag$string$3', 'symbols': [{'literal':'l'}, {'literal':'o'}, {'literal':'w'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'sentiment_alternative_tag', 'symbols': ['sentiment_alternative_tag$string$2', '__', 'sentiment_alternative_tag$string$3']},
      {'name': 'sentiment_alternative_tag$string$4', 'symbols': [{'literal':'s'}, {'literal':'e'}, {'literal':'n'}, {'literal':'t'}, {'literal':'i'}, {'literal':'m'}, {'literal':'e'}, {'literal':'n'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'sentiment_alternative_tag$string$5', 'symbols': [{'literal':'h'}, {'literal':'i'}, {'literal':'g'}, {'literal':'h'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'sentiment_alternative_tag', 'symbols': ['sentiment_alternative_tag$string$4', '__', 'sentiment_alternative_tag$string$5']},
      {'name': 'sentiment_alternative_tag$string$6', 'symbols': [{'literal':'n'}, {'literal':'e'}, {'literal':'w'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'sentiment_alternative_tag$string$7', 'symbols': [{'literal':'v'}, {'literal':'o'}, {'literal':'l'}, {'literal':'u'}, {'literal':'m'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'sentiment_alternative_tag', 'symbols': ['sentiment_alternative_tag$string$6', '__', 'sentiment_alternative_tag$string$7']},
      {'name': 'sentiment_alternative_tag$string$8', 'symbols': [{'literal':'n'}, {'literal':'e'}, {'literal':'w'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'sentiment_alternative_tag$string$9', 'symbols': [{'literal':'b'}, {'literal':'u'}, {'literal':'z'}, {'literal':'z'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'sentiment_alternative_tag', 'symbols': ['sentiment_alternative_tag$string$8', '__', 'sentiment_alternative_tag$string$9']},
      {'name': 'pct_devices_alternative$ebnf$1$subexpression$1', 'symbols': ['ticker', '__']},
      {'name': 'pct_devices_alternative$ebnf$1', 'symbols': ['pct_devices_alternative$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'pct_devices_alternative$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'pct_devices_alternative$ebnf$2$subexpression$1', 'symbols': ['months_back', '__']},
      {'name': 'pct_devices_alternative$ebnf$2$subexpression$1', 'symbols': ['particular_month', '__']},
      {'name': 'pct_devices_alternative$ebnf$2', 'symbols': ['pct_devices_alternative$ebnf$2$subexpression$1'], 'postprocess': id},
      {'name': 'pct_devices_alternative$ebnf$2', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'pct_devices_alternative$ebnf$3$subexpression$1', 'symbols': ['years_back', '__']},
      {'name': 'pct_devices_alternative$ebnf$3$subexpression$1', 'symbols': ['particular_year', '__']},
      {'name': 'pct_devices_alternative$ebnf$3', 'symbols': ['pct_devices_alternative$ebnf$3$subexpression$1'], 'postprocess': id},
      {'name': 'pct_devices_alternative$ebnf$3', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'pct_devices_alternative', 'symbols': ['pct_devices_alternative$ebnf$1', 'pct_devices_alternative$ebnf$2', 'pct_devices_alternative$ebnf$3', 'pct_devices_alternative_tag'], 'postprocess':
        function(data) {
          return {
            kind: 'pct_devices_alternative',
            data: data
          }
        }
      },
      {'name': 'months_back$subexpression$1', 'symbols': ['number_words', '__']},
      {'name': 'months_back$subexpression$1', 'symbols': ['int', '_']},
      {'name': 'months_back$string$1', 'symbols': [{'literal':'m'}, {'literal':'o'}, {'literal':'n'}, {'literal':'t'}, {'literal':'h'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'months_back$ebnf$1', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'months_back$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'months_back$ebnf$2$subexpression$1$string$1', 'symbols': [{'literal':'a'}, {'literal':'g'}, {'literal':'o'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'months_back$ebnf$2$subexpression$1', 'symbols': ['__', 'months_back$ebnf$2$subexpression$1$string$1']},
      {'name': 'months_back$ebnf$2', 'symbols': ['months_back$ebnf$2$subexpression$1'], 'postprocess': id},
      {'name': 'months_back$ebnf$2', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'months_back', 'symbols': ['months_back$subexpression$1', 'months_back$string$1', 'months_back$ebnf$1', 'months_back$ebnf$2']},
      {'name': 'months_back$subexpression$2$string$1', 'symbols': [{'literal':'l'}, {'literal':'a'}, {'literal':'s'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'months_back$subexpression$2', 'symbols': ['months_back$subexpression$2$string$1']},
      {'name': 'months_back$subexpression$2$string$2', 'symbols': [{'literal':'p'}, {'literal':'a'}, {'literal':'s'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'months_back$subexpression$2', 'symbols': ['months_back$subexpression$2$string$2']},
      {'name': 'months_back$subexpression$2$string$3', 'symbols': [{'literal':'p'}, {'literal':'r'}, {'literal':'e'}, {'literal':'v'}, {'literal':'i'}, {'literal':'o'}, {'literal':'u'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'months_back$subexpression$2', 'symbols': ['months_back$subexpression$2$string$3']},
      {'name': 'months_back$subexpression$2$string$4', 'symbols': [{'literal':'c'}, {'literal':'u'}, {'literal':'r'}, {'literal':'r'}, {'literal':'e'}, {'literal':'n'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'months_back$subexpression$2', 'symbols': ['months_back$subexpression$2$string$4']},
      {'name': 'months_back$subexpression$2$string$5', 'symbols': [{'literal':'t'}, {'literal':'h'}, {'literal':'i'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'months_back$subexpression$2', 'symbols': ['months_back$subexpression$2$string$5']},
      {'name': 'months_back$subexpression$2$string$6', 'symbols': [{'literal':'t'}, {'literal':'r'}, {'literal':'a'}, {'literal':'i'}, {'literal':'l'}, {'literal':'i'}, {'literal':'n'}, {'literal':'g'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'months_back$subexpression$2', 'symbols': ['months_back$subexpression$2$string$6']},
      {'name': 'months_back$string$2', 'symbols': [{'literal':'m'}, {'literal':'o'}, {'literal':'n'}, {'literal':'t'}, {'literal':'h'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'months_back', 'symbols': ['months_back$subexpression$2', '__', 'months_back$string$2'], 'postprocess':
        function(data) {
          return {
            kind: 'months_back',
            data: data
          }
        }
      },
      {'name': 'years_back$subexpression$1', 'symbols': ['number_words', '__']},
      {'name': 'years_back$subexpression$1', 'symbols': ['int', '_']},
      {'name': 'years_back$string$1', 'symbols': [{'literal':'y'}, {'literal':'e'}, {'literal':'a'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'years_back$ebnf$1', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'years_back$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'years_back$ebnf$2$subexpression$1$string$1', 'symbols': [{'literal':'a'}, {'literal':'g'}, {'literal':'o'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'years_back$ebnf$2$subexpression$1', 'symbols': ['__', 'years_back$ebnf$2$subexpression$1$string$1']},
      {'name': 'years_back$ebnf$2', 'symbols': ['years_back$ebnf$2$subexpression$1'], 'postprocess': id},
      {'name': 'years_back$ebnf$2', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'years_back', 'symbols': ['years_back$subexpression$1', 'years_back$string$1', 'years_back$ebnf$1', 'years_back$ebnf$2']},
      {'name': 'years_back$string$2', 'symbols': [{'literal':'l'}, {'literal':'a'}, {'literal':'s'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'years_back$string$3', 'symbols': [{'literal':'y'}, {'literal':'e'}, {'literal':'a'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'years_back', 'symbols': ['years_back$string$2', '__', 'years_back$string$3'], 'postprocess':
        function(data) {
          return {
            kind: 'years_back',
            data: data
          }
        }
      },
      {'name': 'particular_month$string$1', 'symbols': [{'literal':'j'}, {'literal':'a'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month$ebnf$1$string$1', 'symbols': [{'literal':'u'}, {'literal':'a'}, {'literal':'r'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month$ebnf$1', 'symbols': ['particular_month$ebnf$1$string$1'], 'postprocess': id},
      {'name': 'particular_month$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'particular_month', 'symbols': ['particular_month$string$1', 'particular_month$ebnf$1']},
      {'name': 'particular_month$string$2', 'symbols': [{'literal':'f'}, {'literal':'e'}, {'literal':'b'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month$ebnf$2$string$1', 'symbols': [{'literal':'r'}, {'literal':'u'}, {'literal':'a'}, {'literal':'r'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month$ebnf$2', 'symbols': ['particular_month$ebnf$2$string$1'], 'postprocess': id},
      {'name': 'particular_month$ebnf$2', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'particular_month', 'symbols': ['particular_month$string$2', 'particular_month$ebnf$2']},
      {'name': 'particular_month$string$3', 'symbols': [{'literal':'m'}, {'literal':'a'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month$string$4', 'symbols': [{'literal':'c'}, {'literal':'h'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month', 'symbols': ['particular_month$string$3', 'particular_month$string$4']},
      {'name': 'particular_month$string$5', 'symbols': [{'literal':'a'}, {'literal':'p'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month$ebnf$3$string$1', 'symbols': [{'literal':'i'}, {'literal':'l'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month$ebnf$3', 'symbols': ['particular_month$ebnf$3$string$1'], 'postprocess': id},
      {'name': 'particular_month$ebnf$3', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'particular_month', 'symbols': ['particular_month$string$5', 'particular_month$ebnf$3']},
      {'name': 'particular_month$string$6', 'symbols': [{'literal':'m'}, {'literal':'a'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month', 'symbols': ['particular_month$string$6']},
      {'name': 'particular_month$string$7', 'symbols': [{'literal':'j'}, {'literal':'u'}, {'literal':'n'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month', 'symbols': ['particular_month$string$7']},
      {'name': 'particular_month$string$8', 'symbols': [{'literal':'j'}, {'literal':'u'}, {'literal':'l'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month', 'symbols': ['particular_month$string$8']},
      {'name': 'particular_month$string$9', 'symbols': [{'literal':'a'}, {'literal':'u'}, {'literal':'g'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month$ebnf$4$string$1', 'symbols': [{'literal':'u'}, {'literal':'s'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month$ebnf$4', 'symbols': ['particular_month$ebnf$4$string$1'], 'postprocess': id},
      {'name': 'particular_month$ebnf$4', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'particular_month', 'symbols': ['particular_month$string$9', 'particular_month$ebnf$4']},
      {'name': 'particular_month$string$10', 'symbols': [{'literal':'s'}, {'literal':'e'}, {'literal':'p'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month$ebnf$5$string$1', 'symbols': [{'literal':'e'}, {'literal':'m'}, {'literal':'b'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month$ebnf$5', 'symbols': ['particular_month$ebnf$5$string$1'], 'postprocess': id},
      {'name': 'particular_month$ebnf$5', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'particular_month', 'symbols': ['particular_month$string$10', 'particular_month$ebnf$5']},
      {'name': 'particular_month$string$11', 'symbols': [{'literal':'o'}, {'literal':'c'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month$ebnf$6$string$1', 'symbols': [{'literal':'o'}, {'literal':'b'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month$ebnf$6', 'symbols': ['particular_month$ebnf$6$string$1'], 'postprocess': id},
      {'name': 'particular_month$ebnf$6', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'particular_month', 'symbols': ['particular_month$string$11', 'particular_month$ebnf$6']},
      {'name': 'particular_month$string$12', 'symbols': [{'literal':'n'}, {'literal':'o'}, {'literal':'v'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month$ebnf$7$string$1', 'symbols': [{'literal':'e'}, {'literal':'m'}, {'literal':'b'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month$ebnf$7', 'symbols': ['particular_month$ebnf$7$string$1'], 'postprocess': id},
      {'name': 'particular_month$ebnf$7', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'particular_month', 'symbols': ['particular_month$string$12', 'particular_month$ebnf$7']},
      {'name': 'particular_month$string$13', 'symbols': [{'literal':'d'}, {'literal':'e'}, {'literal':'c'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month$ebnf$8$string$1', 'symbols': [{'literal':'e'}, {'literal':'m'}, {'literal':'b'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'particular_month$ebnf$8', 'symbols': ['particular_month$ebnf$8$string$1'], 'postprocess': id},
      {'name': 'particular_month$ebnf$8', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'particular_month', 'symbols': ['particular_month$string$13', 'particular_month$ebnf$8'], 'postprocess':
        function(data) {
          return {
            kind: 'particular_month',
            data: data
          }
        }
      },
      {'name': 'particular_year', 'symbols': [/[1-2]/, /[0-9]/, /[0-9]/, /[0-9]/], 'postprocess':
        function(data) {
          return {
            kind: 'particular_year',
            data: data
          }
        }
      },
      {'name': 'pct_devices_alternative_tag$string$1', 'symbols': [{'literal':'p'}, {'literal':'c'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'pct_devices_alternative_tag$string$2', 'symbols': [{'literal':'d'}, {'literal':'e'}, {'literal':'v'}, {'literal':'i'}, {'literal':'c'}, {'literal':'e'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'pct_devices_alternative_tag$string$3', 'symbols': [{'literal':'i'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'pct_devices_alternative_tag$string$4', 'symbols': [{'literal':'s'}, {'literal':'t'}, {'literal':'o'}, {'literal':'r'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'pct_devices_alternative_tag', 'symbols': ['pct_devices_alternative_tag$string$1', '__', 'pct_devices_alternative_tag$string$2', '__', 'pct_devices_alternative_tag$string$3', '__', 'pct_devices_alternative_tag$string$4']},
      {'name': 'pct_devices_alternative_tag$string$5', 'symbols': [{'literal':'p'}, {'literal':'c'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'pct_devices_alternative_tag$string$6', 'symbols': [{'literal':'d'}, {'literal':'e'}, {'literal':'v'}, {'literal':'i'}, {'literal':'c'}, {'literal':'e'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'pct_devices_alternative_tag$string$7', 'symbols': [{'literal':'i'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'pct_devices_alternative_tag$string$8', 'symbols': [{'literal':'p'}, {'literal':'l'}, {'literal':'o'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'pct_devices_alternative_tag', 'symbols': ['pct_devices_alternative_tag$string$5', '__', 'pct_devices_alternative_tag$string$6', '__', 'pct_devices_alternative_tag$string$7', '__', 'pct_devices_alternative_tag$string$8']},
      {'name': 'ticker_algong_with_days_back$ebnf$1$subexpression$1', 'symbols': ['ticker', '_']},
      {'name': 'ticker_algong_with_days_back$ebnf$1', 'symbols': ['ticker_algong_with_days_back$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'ticker_algong_with_days_back$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'ticker_algong_with_days_back$ebnf$2$subexpression$1', 'symbols': ['days_back', '_']},
      {'name': 'ticker_algong_with_days_back$ebnf$2', 'symbols': ['ticker_algong_with_days_back$ebnf$2$subexpression$1'], 'postprocess': id},
      {'name': 'ticker_algong_with_days_back$ebnf$2', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'ticker_algong_with_days_back', 'symbols': ['ticker_algong_with_days_back$ebnf$1', 'ticker_algong_with_days_back$ebnf$2']},
      {'name': 'ticker_algong_with_days_back', 'symbols': ['days_back', '__', 'ticker', '_'], 'postprocess':
        function(data) {
          return {
            kind: 'ticker_algong_with_days_back',
            data: data
          }
        }
      },
      {'name': 'indicator', 'symbols': ['ticker']},
      {'name': 'indicator$subexpression$1', 'symbols': ['opening_price']},
      {'name': 'indicator$subexpression$1', 'symbols': ['closing_price']},
      {'name': 'indicator$subexpression$1$ebnf$1$subexpression$1', 'symbols': ['num_days', '_']},
      {'name': 'indicator$subexpression$1$ebnf$1', 'symbols': ['indicator$subexpression$1$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'indicator$subexpression$1$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'indicator$subexpression$1', 'symbols': ['indicator$subexpression$1$ebnf$1', 'high_price']},
      {'name': 'indicator$subexpression$1$ebnf$2$subexpression$1', 'symbols': ['num_days', '_']},
      {'name': 'indicator$subexpression$1$ebnf$2', 'symbols': ['indicator$subexpression$1$ebnf$2$subexpression$1'], 'postprocess': id},
      {'name': 'indicator$subexpression$1$ebnf$2', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'indicator$subexpression$1', 'symbols': ['indicator$subexpression$1$ebnf$2', 'low_price']},
      {'name': 'indicator$subexpression$1', 'symbols': ['volume']},
      {'name': 'indicator$subexpression$1$ebnf$3$subexpression$1', 'symbols': ['num_days', '_']},
      {'name': 'indicator$subexpression$1$ebnf$3', 'symbols': ['indicator$subexpression$1$ebnf$3$subexpression$1'], 'postprocess': id},
      {'name': 'indicator$subexpression$1$ebnf$3', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'indicator$subexpression$1', 'symbols': ['indicator$subexpression$1$ebnf$3', 'moving_average']},
      {'name': 'indicator$subexpression$1$ebnf$4$subexpression$1', 'symbols': ['num_days', '_']},
      {'name': 'indicator$subexpression$1$ebnf$4', 'symbols': ['indicator$subexpression$1$ebnf$4$subexpression$1'], 'postprocess': id},
      {'name': 'indicator$subexpression$1$ebnf$4', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'indicator$subexpression$1', 'symbols': ['indicator$subexpression$1$ebnf$4', 'exponential_moving_average']},
      {'name': 'indicator$subexpression$1$ebnf$5$subexpression$1', 'symbols': ['num_days', '_']},
      {'name': 'indicator$subexpression$1$ebnf$5', 'symbols': ['indicator$subexpression$1$ebnf$5$subexpression$1'], 'postprocess': id},
      {'name': 'indicator$subexpression$1$ebnf$5', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'indicator$subexpression$1$ebnf$6$subexpression$1$string$1', 'symbols': [{'literal':'w'}, {'literal':'i'}, {'literal':'t'}, {'literal':'h'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'indicator$subexpression$1$ebnf$6$subexpression$1', 'symbols': ['_', 'indicator$subexpression$1$ebnf$6$subexpression$1$string$1']},
      {'name': 'indicator$subexpression$1$ebnf$6', 'symbols': ['indicator$subexpression$1$ebnf$6$subexpression$1'], 'postprocess': id},
      {'name': 'indicator$subexpression$1$ebnf$6', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'indicator$subexpression$1$ebnf$7$subexpression$1', 'symbols': ['_', 'upper_multiplier']},
      {'name': 'indicator$subexpression$1$ebnf$7', 'symbols': ['indicator$subexpression$1$ebnf$7$subexpression$1'], 'postprocess': id},
      {'name': 'indicator$subexpression$1$ebnf$7', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'indicator$subexpression$1$ebnf$8$subexpression$1', 'symbols': ['_', 'lower_multiplier']},
      {'name': 'indicator$subexpression$1$ebnf$8', 'symbols': ['indicator$subexpression$1$ebnf$8$subexpression$1'], 'postprocess': id},
      {'name': 'indicator$subexpression$1$ebnf$8', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'indicator$subexpression$1', 'symbols': ['indicator$subexpression$1$ebnf$5', 'bollinger_type', '_', 'bollinger_bound', 'indicator$subexpression$1$ebnf$6', 'indicator$subexpression$1$ebnf$7', 'indicator$subexpression$1$ebnf$8']},
      {'name': 'indicator$subexpression$1$ebnf$9$subexpression$1', 'symbols': ['num_days', '_']},
      {'name': 'indicator$subexpression$1$ebnf$9', 'symbols': ['indicator$subexpression$1$ebnf$9$subexpression$1'], 'postprocess': id},
      {'name': 'indicator$subexpression$1$ebnf$9', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'indicator$subexpression$1$string$1', 'symbols': [{'literal':'a'}, {'literal':'t'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'indicator$subexpression$1', 'symbols': ['indicator$subexpression$1$ebnf$9', 'indicator$subexpression$1$string$1']},
      {'name': 'indicator$subexpression$1$ebnf$10$subexpression$1', 'symbols': ['num_days', '_']},
      {'name': 'indicator$subexpression$1$ebnf$10', 'symbols': ['indicator$subexpression$1$ebnf$10$subexpression$1'], 'postprocess': id},
      {'name': 'indicator$subexpression$1$ebnf$10', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'indicator$subexpression$1$string$2', 'symbols': [{'literal':'r'}, {'literal':'s'}, {'literal':'i'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'indicator$subexpression$1', 'symbols': ['indicator$subexpression$1$ebnf$10', 'indicator$subexpression$1$string$2']},
      {'name': 'indicator$subexpression$1$ebnf$11$subexpression$1', 'symbols': ['num_days', '_']},
      {'name': 'indicator$subexpression$1$ebnf$11', 'symbols': ['indicator$subexpression$1$ebnf$11$subexpression$1'], 'postprocess': id},
      {'name': 'indicator$subexpression$1$ebnf$11', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'indicator$subexpression$1$string$3', 'symbols': [{'literal':'o'}, {'literal':'b'}, {'literal':'v'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'indicator$subexpression$1', 'symbols': ['indicator$subexpression$1$ebnf$11', 'indicator$subexpression$1$string$3']},
      {'name': 'indicator$subexpression$1$string$4', 'symbols': [{'literal':'m'}, {'literal':'a'}, {'literal':'c'}, {'literal':'d'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'indicator$subexpression$1$ebnf$12$subexpression$1', 'symbols': ['_', 'macd_type']},
      {'name': 'indicator$subexpression$1$ebnf$12', 'symbols': ['indicator$subexpression$1$ebnf$12$subexpression$1'], 'postprocess': id},
      {'name': 'indicator$subexpression$1$ebnf$12', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'indicator$subexpression$1$ebnf$13$subexpression$1$string$1', 'symbols': [{'literal':'w'}, {'literal':'i'}, {'literal':'t'}, {'literal':'h'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'indicator$subexpression$1$ebnf$13$subexpression$1', 'symbols': ['_', 'indicator$subexpression$1$ebnf$13$subexpression$1$string$1']},
      {'name': 'indicator$subexpression$1$ebnf$13', 'symbols': ['indicator$subexpression$1$ebnf$13$subexpression$1'], 'postprocess': id},
      {'name': 'indicator$subexpression$1$ebnf$13', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'indicator$subexpression$1$ebnf$14$subexpression$1', 'symbols': ['_', 'fast_period']},
      {'name': 'indicator$subexpression$1$ebnf$14', 'symbols': ['indicator$subexpression$1$ebnf$14$subexpression$1'], 'postprocess': id},
      {'name': 'indicator$subexpression$1$ebnf$14', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'indicator$subexpression$1$ebnf$15$subexpression$1', 'symbols': ['_', 'slow_period']},
      {'name': 'indicator$subexpression$1$ebnf$15', 'symbols': ['indicator$subexpression$1$ebnf$15$subexpression$1'], 'postprocess': id},
      {'name': 'indicator$subexpression$1$ebnf$15', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'indicator$subexpression$1$ebnf$16$subexpression$1', 'symbols': ['_', 'signal_period']},
      {'name': 'indicator$subexpression$1$ebnf$16', 'symbols': ['indicator$subexpression$1$ebnf$16$subexpression$1'], 'postprocess': id},
      {'name': 'indicator$subexpression$1$ebnf$16', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'indicator$subexpression$1', 'symbols': ['indicator$subexpression$1$string$4', 'indicator$subexpression$1$ebnf$12', 'indicator$subexpression$1$ebnf$13', 'indicator$subexpression$1$ebnf$14', 'indicator$subexpression$1$ebnf$15', 'indicator$subexpression$1$ebnf$16']},
      {'name': 'indicator', 'symbols': ['ticker_algong_with_days_back', 'indicator$subexpression$1'], 'postprocess':
        function(data) {
          return {
            kind: 'indicator',
            data: data
          }
        }
      },
      {'name': 'fast_period$string$1', 'symbols': [{'literal':'f'}, {'literal':'a'}, {'literal':'s'}, {'literal':'t'}, {'literal':'p'}, {'literal':'e'}, {'literal':'r'}, {'literal':'i'}, {'literal':'o'}, {'literal':'d'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'fast_period', 'symbols': ['fast_period$string$1', '_', 'int'], 'postprocess':
        function(data) {
          return {
            kind: 'fast_period',
            data: data
          }
        }
      },
      {'name': 'slow_period$string$1', 'symbols': [{'literal':'s'}, {'literal':'l'}, {'literal':'o'}, {'literal':'w'}, {'literal':'p'}, {'literal':'e'}, {'literal':'r'}, {'literal':'i'}, {'literal':'o'}, {'literal':'d'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'slow_period', 'symbols': ['slow_period$string$1', '_', 'int'], 'postprocess':
        function(data) {
          return {
            kind: 'slow_period',
            data: data
          }
        }
      },
      {'name': 'signal_period$string$1', 'symbols': [{'literal':'s'}, {'literal':'i'}, {'literal':'g'}, {'literal':'n'}, {'literal':'a'}, {'literal':'l'}, {'literal':'p'}, {'literal':'e'}, {'literal':'r'}, {'literal':'i'}, {'literal':'o'}, {'literal':'d'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'signal_period', 'symbols': ['signal_period$string$1', '_', 'int'], 'postprocess':
        function(data) {
          return {
            kind: 'signal_period',
            data: data
          }
        }
      },
      {'name': 'bollinger_type$string$1', 'symbols': [{'literal':'u'}, {'literal':'p'}, {'literal':'p'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'bollinger_type', 'symbols': ['bollinger_type$string$1']},
      {'name': 'bollinger_type$string$2', 'symbols': [{'literal':'m'}, {'literal':'i'}, {'literal':'d'}, {'literal':'d'}, {'literal':'l'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'bollinger_type', 'symbols': ['bollinger_type$string$2']},
      {'name': 'bollinger_type$string$3', 'symbols': [{'literal':'l'}, {'literal':'o'}, {'literal':'w'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'bollinger_type', 'symbols': ['bollinger_type$string$3'], 'postprocess':
        function(data) {
          return {
            kind: 'bollinger_type',
            data: data
          }
        }
      },
      {'name': 'bollinger_bound$string$1', 'symbols': [{'literal':'b'}, {'literal':'o'}, {'literal':'l'}, {'literal':'l'}, {'literal':'i'}, {'literal':'n'}, {'literal':'g'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'bollinger_bound$subexpression$1$string$1', 'symbols': [{'literal':'b'}, {'literal':'o'}, {'literal':'u'}, {'literal':'n'}, {'literal':'d'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'bollinger_bound$subexpression$1', 'symbols': ['bollinger_bound$subexpression$1$string$1']},
      {'name': 'bollinger_bound$subexpression$1$string$2', 'symbols': [{'literal':'b'}, {'literal':'a'}, {'literal':'n'}, {'literal':'d'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'bollinger_bound$subexpression$1', 'symbols': ['bollinger_bound$subexpression$1$string$2']},
      {'name': 'bollinger_bound', 'symbols': ['bollinger_bound$string$1', '_', 'bollinger_bound$subexpression$1'], 'postprocess':
        function(data) {
          return {
            kind: 'bollinger_bound',
            data: data
          }
        }
      },
      {'name': 'upper_multiplier$string$1', 'symbols': [{'literal':'u'}, {'literal':'p'}, {'literal':'p'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'upper_multiplier$string$2', 'symbols': [{'literal':'m'}, {'literal':'u'}, {'literal':'l'}, {'literal':'t'}, {'literal':'i'}, {'literal':'p'}, {'literal':'l'}, {'literal':'i'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'upper_multiplier', 'symbols': ['upper_multiplier$string$1', '_', 'upper_multiplier$string$2', '_', 'decimal'], 'postprocess':
        function(data) {
          return {
            kind: 'upper_multiplier',
            data: data
          }
        }
      },
      {'name': 'lower_multiplier$string$1', 'symbols': [{'literal':'l'}, {'literal':'o'}, {'literal':'w'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'lower_multiplier$string$2', 'symbols': [{'literal':'m'}, {'literal':'u'}, {'literal':'l'}, {'literal':'t'}, {'literal':'i'}, {'literal':'p'}, {'literal':'l'}, {'literal':'i'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'lower_multiplier', 'symbols': ['lower_multiplier$string$1', '_', 'lower_multiplier$string$2', '_', 'decimal'], 'postprocess':
        function(data) {
          return {
            kind: 'lower_multiplier',
            data: data
          }
        }
      },
      {'name': 'moving_average$ebnf$1$subexpression$1$string$1', 'symbols': [{'literal':'s'}, {'literal':'i'}, {'literal':'m'}, {'literal':'p'}, {'literal':'l'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'moving_average$ebnf$1$subexpression$1', 'symbols': ['moving_average$ebnf$1$subexpression$1$string$1', '__']},
      {'name': 'moving_average$ebnf$1', 'symbols': ['moving_average$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'moving_average$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'moving_average$string$1', 'symbols': [{'literal':'m'}, {'literal':'o'}, {'literal':'v'}, {'literal':'i'}, {'literal':'n'}, {'literal':'g'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'moving_average$string$2', 'symbols': [{'literal':'a'}, {'literal':'v'}, {'literal':'e'}, {'literal':'r'}, {'literal':'a'}, {'literal':'g'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'moving_average', 'symbols': ['moving_average$ebnf$1', 'moving_average$string$1', '_', 'moving_average$string$2'], 'postprocess':
        function(data) {
          return {
            kind: 'moving_average',
            data: data
          }
        }
      },
      {'name': 'exponential_moving_average$string$1', 'symbols': [{'literal':'e'}, {'literal':'x'}, {'literal':'p'}, {'literal':'o'}, {'literal':'n'}, {'literal':'e'}, {'literal':'n'}, {'literal':'t'}, {'literal':'i'}, {'literal':'a'}, {'literal':'l'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'exponential_moving_average$string$2', 'symbols': [{'literal':'m'}, {'literal':'o'}, {'literal':'v'}, {'literal':'i'}, {'literal':'n'}, {'literal':'g'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'exponential_moving_average$string$3', 'symbols': [{'literal':'a'}, {'literal':'v'}, {'literal':'e'}, {'literal':'r'}, {'literal':'a'}, {'literal':'g'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'exponential_moving_average', 'symbols': ['exponential_moving_average$string$1', '_', 'exponential_moving_average$string$2', '_', 'exponential_moving_average$string$3'], 'postprocess':
        function(data) {
          return {
            kind: 'exponential_moving_average',
            data: data
          }
        }
      },
      {'name': 'ticker', 'symbols': ['symbol'], 'postprocess':
        function(data) {
          return {
            kind: 'ticker',
            data: data
          }
        }
      },
      {'name': 'days_back$subexpression$1', 'symbols': ['int', '_']},
      {'name': 'days_back$subexpression$1', 'symbols': ['number_words', '__']},
      {'name': 'days_back', 'symbols': ['days_back$subexpression$1', 'days_back_day_ago_part']},
      {'name': 'days_back$string$1', 'symbols': [{'literal':'l'}, {'literal':'a'}, {'literal':'s'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'days_back$string$2', 'symbols': [{'literal':'m'}, {'literal':'o'}, {'literal':'n'}, {'literal':'t'}, {'literal':'h'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'days_back', 'symbols': ['days_back$string$1', '__', 'days_back$string$2']},
      {'name': 'days_back$string$3', 'symbols': [{'literal':'p'}, {'literal':'r'}, {'literal':'e'}, {'literal':'v'}, {'literal':'i'}, {'literal':'o'}, {'literal':'u'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'days_back', 'symbols': ['days_back$string$3']},
      {'name': 'days_back$string$4', 'symbols': [{'literal':'y'}, {'literal':'e'}, {'literal':'s'}, {'literal':'t'}, {'literal':'e'}, {'literal':'r'}, {'literal':'d'}, {'literal':'a'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'days_back$ebnf$1$subexpression$1', 'symbols': [{'literal':'s'}]},
      {'name': 'days_back$ebnf$1$subexpression$1$string$1', 'symbols': [{'literal':'\''}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'days_back$ebnf$1$subexpression$1', 'symbols': ['days_back$ebnf$1$subexpression$1$string$1']},
      {'name': 'days_back$ebnf$1', 'symbols': ['days_back$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'days_back$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'days_back', 'symbols': ['days_back$string$4', 'days_back$ebnf$1']},
      {'name': 'days_back$string$5', 'symbols': [{'literal':'p'}, {'literal':'a'}, {'literal':'s'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'days_back', 'symbols': ['days_back$string$5']},
      {'name': 'days_back$string$6', 'symbols': [{'literal':'t'}, {'literal':'o'}, {'literal':'d'}, {'literal':'a'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'days_back$ebnf$2$subexpression$1', 'symbols': [{'literal':'s'}]},
      {'name': 'days_back$ebnf$2$subexpression$1$string$1', 'symbols': [{'literal':'\''}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'days_back$ebnf$2$subexpression$1', 'symbols': ['days_back$ebnf$2$subexpression$1$string$1']},
      {'name': 'days_back$ebnf$2', 'symbols': ['days_back$ebnf$2$subexpression$1'], 'postprocess': id},
      {'name': 'days_back$ebnf$2', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'days_back', 'symbols': ['days_back$string$6', 'days_back$ebnf$2']},
      {'name': 'days_back$string$7', 'symbols': [{'literal':'c'}, {'literal':'u'}, {'literal':'r'}, {'literal':'r'}, {'literal':'e'}, {'literal':'n'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'days_back', 'symbols': ['days_back$string$7'], 'postprocess':
        function(data) {
          return {
            kind: 'days_back',
            data: data
          }
        }
      },
      {'name': 'days_back_day_ago_part$subexpression$1$string$1', 'symbols': [{'literal':'d'}, {'literal':'a'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'days_back_day_ago_part$subexpression$1$ebnf$1', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'days_back_day_ago_part$subexpression$1$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'days_back_day_ago_part$subexpression$1', 'symbols': ['days_back_day_ago_part$subexpression$1$string$1', 'days_back_day_ago_part$subexpression$1$ebnf$1']},
      {'name': 'days_back_day_ago_part$subexpression$1$string$2', 'symbols': [{'literal':'w'}, {'literal':'e'}, {'literal':'e'}, {'literal':'k'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'days_back_day_ago_part$subexpression$1$ebnf$2', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'days_back_day_ago_part$subexpression$1$ebnf$2', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'days_back_day_ago_part$subexpression$1', 'symbols': ['days_back_day_ago_part$subexpression$1$string$2', 'days_back_day_ago_part$subexpression$1$ebnf$2']},
      {'name': 'days_back_day_ago_part$subexpression$1$string$3', 'symbols': [{'literal':'m'}, {'literal':'o'}, {'literal':'n'}, {'literal':'t'}, {'literal':'h'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'days_back_day_ago_part$subexpression$1$ebnf$3', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'days_back_day_ago_part$subexpression$1$ebnf$3', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'days_back_day_ago_part$subexpression$1', 'symbols': ['days_back_day_ago_part$subexpression$1$string$3', 'days_back_day_ago_part$subexpression$1$ebnf$3']},
      {'name': 'days_back_day_ago_part', 'symbols': ['days_back_day_ago_part$subexpression$1', '__', 'ago'], 'postprocess':
        function(data) {
          return {
            kind: 'days_back_day_ago_part',
            data: data
          }
        }
      },
      {'name': 'opening_price$string$1', 'symbols': [{'literal':'o'}, {'literal':'p'}, {'literal':'e'}, {'literal':'n'}, {'literal':'i'}, {'literal':'n'}, {'literal':'g'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'opening_price$string$2', 'symbols': [{'literal':'p'}, {'literal':'r'}, {'literal':'i'}, {'literal':'c'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'opening_price', 'symbols': ['opening_price$string$1', '__', 'opening_price$string$2']},
      {'name': 'opening_price$string$3', 'symbols': [{'literal':'o'}, {'literal':'p'}, {'literal':'e'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'opening_price$ebnf$1$subexpression$1$string$1', 'symbols': [{'literal':'p'}, {'literal':'r'}, {'literal':'i'}, {'literal':'c'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'opening_price$ebnf$1$subexpression$1', 'symbols': ['__', 'opening_price$ebnf$1$subexpression$1$string$1']},
      {'name': 'opening_price$ebnf$1', 'symbols': ['opening_price$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'opening_price$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'opening_price', 'symbols': ['opening_price$string$3', 'opening_price$ebnf$1'], 'postprocess':
        function(data) {
          return {
            kind: 'opening_price',
            data: data
          }
        }
      },
      {'name': 'closing_price$string$1', 'symbols': [{'literal':'c'}, {'literal':'l'}, {'literal':'o'}, {'literal':'s'}, {'literal':'i'}, {'literal':'n'}, {'literal':'g'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'closing_price$string$2', 'symbols': [{'literal':'p'}, {'literal':'r'}, {'literal':'i'}, {'literal':'c'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'closing_price', 'symbols': ['closing_price$string$1', '__', 'closing_price$string$2']},
      {'name': 'closing_price$string$3', 'symbols': [{'literal':'c'}, {'literal':'l'}, {'literal':'o'}, {'literal':'s'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'closing_price$ebnf$1$subexpression$1$string$1', 'symbols': [{'literal':'p'}, {'literal':'r'}, {'literal':'i'}, {'literal':'c'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'closing_price$ebnf$1$subexpression$1', 'symbols': ['__', 'closing_price$ebnf$1$subexpression$1$string$1']},
      {'name': 'closing_price$ebnf$1', 'symbols': ['closing_price$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'closing_price$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'closing_price', 'symbols': ['closing_price$string$3', 'closing_price$ebnf$1']},
      {'name': 'closing_price$string$4', 'symbols': [{'literal':'p'}, {'literal':'r'}, {'literal':'i'}, {'literal':'c'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'closing_price', 'symbols': ['closing_price$string$4'], 'postprocess':
        function(data) {
          return {
            kind: 'closing_price',
            data: data
          }
        }
      },
      {'name': 'high_price$string$1', 'symbols': [{'literal':'h'}, {'literal':'i'}, {'literal':'g'}, {'literal':'h'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'high_price$ebnf$1$subexpression$1$string$1', 'symbols': [{'literal':'p'}, {'literal':'r'}, {'literal':'i'}, {'literal':'c'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'high_price$ebnf$1$subexpression$1', 'symbols': ['__', 'high_price$ebnf$1$subexpression$1$string$1']},
      {'name': 'high_price$ebnf$1', 'symbols': ['high_price$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'high_price$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'high_price', 'symbols': ['high_price$string$1', 'high_price$ebnf$1'], 'postprocess':
        function(data) {
          return {
            kind: 'high_price',
            data: data
          }
        }
      },
      {'name': 'low_price$string$1', 'symbols': [{'literal':'l'}, {'literal':'o'}, {'literal':'w'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'low_price$ebnf$1$subexpression$1$string$1', 'symbols': [{'literal':'p'}, {'literal':'r'}, {'literal':'i'}, {'literal':'c'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'low_price$ebnf$1$subexpression$1', 'symbols': ['__', 'low_price$ebnf$1$subexpression$1$string$1']},
      {'name': 'low_price$ebnf$1', 'symbols': ['low_price$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'low_price$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'low_price', 'symbols': ['low_price$string$1', 'low_price$ebnf$1'], 'postprocess':
        function(data) {
          return {
            kind: 'low_price',
            data: data
          }
        }
      },
      {'name': 'volume$string$1', 'symbols': [{'literal':'v'}, {'literal':'o'}, {'literal':'l'}, {'literal':'u'}, {'literal':'m'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'volume', 'symbols': ['volume$string$1'], 'postprocess':
        function(data) {
          return {
            kind: 'volume',
            data: data
          }
        }
      },
      {'name': 'macd_type$string$1', 'symbols': [{'literal':'s'}, {'literal':'i'}, {'literal':'g'}, {'literal':'n'}, {'literal':'a'}, {'literal':'l'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'macd_type', 'symbols': ['macd_type$string$1']},
      {'name': 'macd_type$string$2', 'symbols': [{'literal':'h'}, {'literal':'i'}, {'literal':'s'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'macd_type', 'symbols': ['macd_type$string$2'], 'postprocess':
        function(data) {
          return {
            kind: 'macd_type',
            data: data
          }
        }
      },
      {'name': 'number_words$string$1', 'symbols': [{'literal':'z'}, {'literal':'e'}, {'literal':'r'}, {'literal':'o'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$1']},
      {'name': 'number_words$string$2', 'symbols': [{'literal':'o'}, {'literal':'n'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$2']},
      {'name': 'number_words$string$3', 'symbols': [{'literal':'t'}, {'literal':'w'}, {'literal':'o'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$3']},
      {'name': 'number_words$string$4', 'symbols': [{'literal':'t'}, {'literal':'h'}, {'literal':'r'}, {'literal':'e'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$4']},
      {'name': 'number_words$string$5', 'symbols': [{'literal':'f'}, {'literal':'o'}, {'literal':'u'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$5']},
      {'name': 'number_words$string$6', 'symbols': [{'literal':'f'}, {'literal':'i'}, {'literal':'v'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$6']},
      {'name': 'number_words$string$7', 'symbols': [{'literal':'s'}, {'literal':'i'}, {'literal':'x'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$7']},
      {'name': 'number_words$string$8', 'symbols': [{'literal':'s'}, {'literal':'e'}, {'literal':'v'}, {'literal':'e'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$8']},
      {'name': 'number_words$string$9', 'symbols': [{'literal':'e'}, {'literal':'i'}, {'literal':'g'}, {'literal':'h'}, {'literal':'t'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$9']},
      {'name': 'number_words$string$10', 'symbols': [{'literal':'n'}, {'literal':'i'}, {'literal':'n'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$10']},
      {'name': 'number_words$string$11', 'symbols': [{'literal':'t'}, {'literal':'e'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$11']},
      {'name': 'number_words$string$12', 'symbols': [{'literal':'e'}, {'literal':'l'}, {'literal':'e'}, {'literal':'v'}, {'literal':'e'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$12']},
      {'name': 'number_words$string$13', 'symbols': [{'literal':'t'}, {'literal':'w'}, {'literal':'e'}, {'literal':'l'}, {'literal':'v'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$13']},
      {'name': 'number_words$string$14', 'symbols': [{'literal':'t'}, {'literal':'h'}, {'literal':'i'}, {'literal':'r'}, {'literal':'t'}, {'literal':'e'}, {'literal':'e'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$14']},
      {'name': 'number_words$string$15', 'symbols': [{'literal':'f'}, {'literal':'o'}, {'literal':'u'}, {'literal':'r'}, {'literal':'t'}, {'literal':'e'}, {'literal':'e'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$15']},
      {'name': 'number_words$string$16', 'symbols': [{'literal':'f'}, {'literal':'i'}, {'literal':'f'}, {'literal':'t'}, {'literal':'e'}, {'literal':'e'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$16']},
      {'name': 'number_words$string$17', 'symbols': [{'literal':'s'}, {'literal':'i'}, {'literal':'x'}, {'literal':'t'}, {'literal':'e'}, {'literal':'e'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$17']},
      {'name': 'number_words$string$18', 'symbols': [{'literal':'s'}, {'literal':'e'}, {'literal':'v'}, {'literal':'e'}, {'literal':'n'}, {'literal':'t'}, {'literal':'e'}, {'literal':'e'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$18']},
      {'name': 'number_words$string$19', 'symbols': [{'literal':'e'}, {'literal':'i'}, {'literal':'g'}, {'literal':'h'}, {'literal':'t'}, {'literal':'e'}, {'literal':'e'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$19']},
      {'name': 'number_words$string$20', 'symbols': [{'literal':'n'}, {'literal':'i'}, {'literal':'n'}, {'literal':'e'}, {'literal':'t'}, {'literal':'e'}, {'literal':'e'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$20']},
      {'name': 'number_words$string$21', 'symbols': [{'literal':'t'}, {'literal':'w'}, {'literal':'e'}, {'literal':'n'}, {'literal':'t'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$21']},
      {'name': 'number_words$string$22', 'symbols': [{'literal':'t'}, {'literal':'h'}, {'literal':'i'}, {'literal':'r'}, {'literal':'t'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$22']},
      {'name': 'number_words$string$23', 'symbols': [{'literal':'f'}, {'literal':'o'}, {'literal':'r'}, {'literal':'t'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$23']},
      {'name': 'number_words$string$24', 'symbols': [{'literal':'f'}, {'literal':'i'}, {'literal':'f'}, {'literal':'t'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$24']},
      {'name': 'number_words$string$25', 'symbols': [{'literal':'s'}, {'literal':'i'}, {'literal':'x'}, {'literal':'t'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$25']},
      {'name': 'number_words$string$26', 'symbols': [{'literal':'s'}, {'literal':'e'}, {'literal':'v'}, {'literal':'e'}, {'literal':'n'}, {'literal':'t'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$26']},
      {'name': 'number_words$string$27', 'symbols': [{'literal':'e'}, {'literal':'i'}, {'literal':'g'}, {'literal':'h'}, {'literal':'t'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$27']},
      {'name': 'number_words$string$28', 'symbols': [{'literal':'n'}, {'literal':'i'}, {'literal':'n'}, {'literal':'e'}, {'literal':'t'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$28']},
      {'name': 'number_words$string$29', 'symbols': [{'literal':'h'}, {'literal':'u'}, {'literal':'n'}, {'literal':'d'}, {'literal':'r'}, {'literal':'e'}, {'literal':'d'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$29']},
      {'name': 'number_words$string$30', 'symbols': [{'literal':'t'}, {'literal':'h'}, {'literal':'o'}, {'literal':'u'}, {'literal':'s'}, {'literal':'a'}, {'literal':'n'}, {'literal':'d'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$30']},
      {'name': 'number_words$string$31', 'symbols': [{'literal':'m'}, {'literal':'i'}, {'literal':'l'}, {'literal':'l'}, {'literal':'i'}, {'literal':'o'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$31']},
      {'name': 'number_words$string$32', 'symbols': [{'literal':'b'}, {'literal':'i'}, {'literal':'l'}, {'literal':'l'}, {'literal':'i'}, {'literal':'o'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$32']},
      {'name': 'number_words$string$33', 'symbols': [{'literal':'t'}, {'literal':'r'}, {'literal':'i'}, {'literal':'l'}, {'literal':'l'}, {'literal':'i'}, {'literal':'o'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'number_words', 'symbols': ['number_words$string$33'], 'postprocess':
        function(data) {
          return {
            kind: 'number_words',
            data: data
          }
        }
      },
      {'name': 'synonyms_of_is$string$1', 'symbols': [{'literal':'i'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'synonyms_of_is', 'symbols': ['synonyms_of_is$string$1']},
      {'name': 'synonyms_of_is$string$2', 'symbols': [{'literal':'a'}, {'literal':'r'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'synonyms_of_is', 'symbols': ['synonyms_of_is$string$2']},
      {'name': 'synonyms_of_is$string$3', 'symbols': [{'literal':'t'}, {'literal':'r'}, {'literal':'a'}, {'literal':'d'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'synonyms_of_is', 'symbols': ['synonyms_of_is$string$3']},
      {'name': 'synonyms_of_is$string$4', 'symbols': [{'literal':'t'}, {'literal':'r'}, {'literal':'a'}, {'literal':'d'}, {'literal':'e'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'synonyms_of_is', 'symbols': ['synonyms_of_is$string$4']},
      {'name': 'synonyms_of_is$string$5', 'symbols': [{'literal':'t'}, {'literal':'r'}, {'literal':'a'}, {'literal':'d'}, {'literal':'i'}, {'literal':'n'}, {'literal':'g'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'synonyms_of_is', 'symbols': ['synonyms_of_is$string$5']},
      {'name': 'synonyms_of_is$string$6', 'symbols': [{'literal':'w'}, {'literal':'a'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'synonyms_of_is', 'symbols': ['synonyms_of_is$string$6']},
      {'name': 'synonyms_of_is$string$7', 'symbols': [{'literal':'w'}, {'literal':'e'}, {'literal':'r'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'synonyms_of_is', 'symbols': ['synonyms_of_is$string$7'], 'postprocess':
        function(data) {
          return {
            kind: 'synonyms_of_is',
            data: data
          }
        }
      },
      {'name': 'greater_than$ebnf$1$subexpression$1', 'symbols': ['synonyms_of_is', '_']},
      {'name': 'greater_than$ebnf$1', 'symbols': ['greater_than$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'greater_than$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'greater_than$subexpression$1', 'symbols': ['_', 'greater_than_with_percentage']},
      {'name': 'greater_than$subexpression$1', 'symbols': ['greater_than__above_part']},
      {'name': 'greater_than', 'symbols': ['greater_than$ebnf$1', 'greater_than$subexpression$1'], 'postprocess':
        function(data) {
          return {
            kind: 'greater_than',
            data: data
          }
        }
      },
      {'name': 'greater_than_with_percentage', 'symbols': ['percentage_with_empty_parts', '_', 'greater_than__above_part'], 'postprocess':
        function(data) {
          return {
            kind: 'greater_than_with_percentage',
            data: data
          }
        }
      },
      {'name': 'greater_than__above_part$subexpression$1$subexpression$1$string$1', 'symbols': [{'literal':'l'}, {'literal':'a'}, {'literal':'r'}, {'literal':'g'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'greater_than__above_part$subexpression$1$subexpression$1', 'symbols': ['greater_than__above_part$subexpression$1$subexpression$1$string$1']},
      {'name': 'greater_than__above_part$subexpression$1$subexpression$1$string$2', 'symbols': [{'literal':'g'}, {'literal':'r'}, {'literal':'e'}, {'literal':'a'}, {'literal':'t'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'greater_than__above_part$subexpression$1$subexpression$1', 'symbols': ['greater_than__above_part$subexpression$1$subexpression$1$string$2']},
      {'name': 'greater_than__above_part$subexpression$1$subexpression$1$string$3', 'symbols': [{'literal':'h'}, {'literal':'i'}, {'literal':'g'}, {'literal':'h'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'greater_than__above_part$subexpression$1$subexpression$1', 'symbols': ['greater_than__above_part$subexpression$1$subexpression$1$string$3']},
      {'name': 'greater_than__above_part$subexpression$1$subexpression$1$string$4', 'symbols': [{'literal':'b'}, {'literal':'i'}, {'literal':'g'}, {'literal':'g'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'greater_than__above_part$subexpression$1$subexpression$1', 'symbols': ['greater_than__above_part$subexpression$1$subexpression$1$string$4']},
      {'name': 'greater_than__above_part$subexpression$1$subexpression$1$string$5', 'symbols': [{'literal':'a'}, {'literal':'b'}, {'literal':'o'}, {'literal':'v'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'greater_than__above_part$subexpression$1$subexpression$1', 'symbols': ['greater_than__above_part$subexpression$1$subexpression$1$string$5']},
      {'name': 'greater_than__above_part$subexpression$1$subexpression$1$string$6', 'symbols': [{'literal':'m'}, {'literal':'o'}, {'literal':'r'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'greater_than__above_part$subexpression$1$subexpression$1', 'symbols': ['greater_than__above_part$subexpression$1$subexpression$1$string$6']},
      {'name': 'greater_than__above_part$subexpression$1', 'symbols': ['__', 'greater_than__above_part$subexpression$1$subexpression$1', '__']},
      {'name': 'greater_than__above_part$subexpression$1', 'symbols': [{'literal':'>'}]},
      {'name': 'greater_than__above_part$ebnf$1$subexpression$1$string$1', 'symbols': [{'literal':'t'}, {'literal':'h'}, {'literal':'a'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'greater_than__above_part$ebnf$1$subexpression$1', 'symbols': ['greater_than__above_part$ebnf$1$subexpression$1$string$1']},
      {'name': 'greater_than__above_part$ebnf$1', 'symbols': ['greater_than__above_part$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'greater_than__above_part$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'greater_than__above_part', 'symbols': ['greater_than__above_part$subexpression$1', 'greater_than__above_part$ebnf$1'], 'postprocess':
        function(data) {
          return {
            kind: 'greater_than__above_part',
            data: data
          }
        }
      },
      {'name': 'less_than$ebnf$1$subexpression$1', 'symbols': ['synonyms_of_is', '_']},
      {'name': 'less_than$ebnf$1', 'symbols': ['less_than$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'less_than$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'less_than$subexpression$1', 'symbols': ['_', 'less_than_with_percentage']},
      {'name': 'less_than$subexpression$1', 'symbols': ['less_than__below_part']},
      {'name': 'less_than', 'symbols': ['less_than$ebnf$1', 'less_than$subexpression$1'], 'postprocess':
        function(data) {
          return {
            kind: 'less_than',
            data: data
          }
        }
      },
      {'name': 'less_than_with_percentage', 'symbols': ['percentage_with_empty_parts', '_', 'less_than__below_part'], 'postprocess':
        function(data) {
          return {
            kind: 'less_than_with_percentage',
            data: data
          }
        }
      },
      {'name': 'less_than__below_part$subexpression$1$subexpression$1$string$1', 'symbols': [{'literal':'l'}, {'literal':'e'}, {'literal':'s'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'less_than__below_part$subexpression$1$subexpression$1', 'symbols': ['less_than__below_part$subexpression$1$subexpression$1$string$1']},
      {'name': 'less_than__below_part$subexpression$1$subexpression$1$string$2', 'symbols': [{'literal':'s'}, {'literal':'m'}, {'literal':'a'}, {'literal':'l'}, {'literal':'l'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'less_than__below_part$subexpression$1$subexpression$1', 'symbols': ['less_than__below_part$subexpression$1$subexpression$1$string$2']},
      {'name': 'less_than__below_part$subexpression$1$subexpression$1$string$3', 'symbols': [{'literal':'b'}, {'literal':'e'}, {'literal':'l'}, {'literal':'o'}, {'literal':'w'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'less_than__below_part$subexpression$1$subexpression$1', 'symbols': ['less_than__below_part$subexpression$1$subexpression$1$string$3']},
      {'name': 'less_than__below_part$subexpression$1$subexpression$1$string$4', 'symbols': [{'literal':'l'}, {'literal':'o'}, {'literal':'w'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'less_than__below_part$subexpression$1$subexpression$1', 'symbols': ['less_than__below_part$subexpression$1$subexpression$1$string$4']},
      {'name': 'less_than__below_part$subexpression$1', 'symbols': ['__', 'less_than__below_part$subexpression$1$subexpression$1', '__']},
      {'name': 'less_than__below_part$subexpression$1', 'symbols': [{'literal':'<'}]},
      {'name': 'less_than__below_part$ebnf$1$subexpression$1$string$1', 'symbols': [{'literal':'t'}, {'literal':'h'}, {'literal':'a'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'less_than__below_part$ebnf$1$subexpression$1', 'symbols': ['less_than__below_part$ebnf$1$subexpression$1$string$1']},
      {'name': 'less_than__below_part$ebnf$1', 'symbols': ['less_than__below_part$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'less_than__below_part$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'less_than__below_part', 'symbols': ['less_than__below_part$subexpression$1', 'less_than__below_part$ebnf$1'], 'postprocess':
        function(data) {
          return {
            kind: 'less_than__below_part',
            data: data
          }
        }
      },
      {'name': 'equals$ebnf$1$subexpression$1', 'symbols': ['synonyms_of_is', '_']},
      {'name': 'equals$ebnf$1', 'symbols': ['equals$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'equals$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'equals', 'symbols': ['equals$ebnf$1', 'equals__equals_to_part'], 'postprocess':
        function(data) {
          return {
            kind: 'equals',
            data: data
          }
        }
      },
      {'name': 'equals__equals_to_part$subexpression$1$string$1', 'symbols': [{'literal':'e'}, {'literal':'q'}, {'literal':'u'}, {'literal':'a'}, {'literal':'l'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'equals__equals_to_part$subexpression$1$ebnf$1', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'equals__equals_to_part$subexpression$1$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'equals__equals_to_part$subexpression$1', 'symbols': ['__', 'equals__equals_to_part$subexpression$1$string$1', 'equals__equals_to_part$subexpression$1$ebnf$1', '__']},
      {'name': 'equals__equals_to_part$subexpression$1$string$2', 'symbols': [{'literal':'='}, {'literal':'='}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'equals__equals_to_part$subexpression$1', 'symbols': ['equals__equals_to_part$subexpression$1$string$2']},
      {'name': 'equals__equals_to_part$subexpression$1', 'symbols': [{'literal':'='}]},
      {'name': 'equals__equals_to_part$subexpression$1$string$3', 'symbols': [{'literal':'i'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'equals__equals_to_part$subexpression$1', 'symbols': ['__', 'equals__equals_to_part$subexpression$1$string$3', '__']},
      {'name': 'equals__equals_to_part$ebnf$1$subexpression$1$string$1', 'symbols': [{'literal':'t'}, {'literal':'o'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'equals__equals_to_part$ebnf$1$subexpression$1', 'symbols': ['equals__equals_to_part$ebnf$1$subexpression$1$string$1']},
      {'name': 'equals__equals_to_part$ebnf$1', 'symbols': ['equals__equals_to_part$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'equals__equals_to_part$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'equals__equals_to_part', 'symbols': ['equals__equals_to_part$subexpression$1', 'equals__equals_to_part$ebnf$1'], 'postprocess':
        function(data) {
          return {
            kind: 'equals__equals_to_part',
            data: data
          }
        }
      },
      {'name': 'cross_up$ebnf$1$subexpression$1', 'symbols': ['synonyms_of_is', '__']},
      {'name': 'cross_up$ebnf$1', 'symbols': ['cross_up$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'cross_up$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'cross_up$subexpression$1', 'symbols': ['cross_up_part_1']},
      {'name': 'cross_up$subexpression$1', 'symbols': ['cross_up_part_2']},
      {'name': 'cross_up', 'symbols': ['cross_up$ebnf$1', 'cross_up$subexpression$1'], 'postprocess':
        function(data) {
          return {
            kind: 'cross_up',
            data: data
          }
        }
      },
      {'name': 'cross_up_part_1$subexpression$1$string$1', 'symbols': [{'literal':'c'}, {'literal':'r'}, {'literal':'o'}, {'literal':'s'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_up_part_1$subexpression$1$ebnf$1$subexpression$1$string$1', 'symbols': [{'literal':'e'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_up_part_1$subexpression$1$ebnf$1$subexpression$1', 'symbols': ['cross_up_part_1$subexpression$1$ebnf$1$subexpression$1$string$1']},
      {'name': 'cross_up_part_1$subexpression$1$ebnf$1$subexpression$1$string$2', 'symbols': [{'literal':'e'}, {'literal':'d'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_up_part_1$subexpression$1$ebnf$1$subexpression$1', 'symbols': ['cross_up_part_1$subexpression$1$ebnf$1$subexpression$1$string$2']},
      {'name': 'cross_up_part_1$subexpression$1$ebnf$1', 'symbols': ['cross_up_part_1$subexpression$1$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'cross_up_part_1$subexpression$1$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'cross_up_part_1$subexpression$1', 'symbols': ['cross_up_part_1$subexpression$1$string$1', 'cross_up_part_1$subexpression$1$ebnf$1']},
      {'name': 'cross_up_part_1$subexpression$1$string$2', 'symbols': [{'literal':'g'}, {'literal':'o'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_up_part_1$subexpression$1$ebnf$2$string$1', 'symbols': [{'literal':'e'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_up_part_1$subexpression$1$ebnf$2', 'symbols': ['cross_up_part_1$subexpression$1$ebnf$2$string$1'], 'postprocess': id},
      {'name': 'cross_up_part_1$subexpression$1$ebnf$2', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'cross_up_part_1$subexpression$1', 'symbols': ['cross_up_part_1$subexpression$1$string$2', 'cross_up_part_1$subexpression$1$ebnf$2']},
      {'name': 'cross_up_part_1$subexpression$1$string$3', 'symbols': [{'literal':'m'}, {'literal':'o'}, {'literal':'v'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_up_part_1$subexpression$1$ebnf$3', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'cross_up_part_1$subexpression$1$ebnf$3', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'cross_up_part_1$subexpression$1', 'symbols': ['cross_up_part_1$subexpression$1$string$3', 'cross_up_part_1$subexpression$1$ebnf$3']},
      {'name': 'cross_up_part_1$subexpression$1$string$4', 'symbols': [{'literal':'r'}, {'literal':'i'}, {'literal':'s'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_up_part_1$subexpression$1$ebnf$4', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'cross_up_part_1$subexpression$1$ebnf$4', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'cross_up_part_1$subexpression$1', 'symbols': ['cross_up_part_1$subexpression$1$string$4', 'cross_up_part_1$subexpression$1$ebnf$4']},
      {'name': 'cross_up_part_1$subexpression$2$string$1', 'symbols': [{'literal':'a'}, {'literal':'b'}, {'literal':'o'}, {'literal':'v'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_up_part_1$subexpression$2', 'symbols': ['cross_up_part_1$subexpression$2$string$1']},
      {'name': 'cross_up_part_1$subexpression$2$string$2', 'symbols': [{'literal':'u'}, {'literal':'p'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_up_part_1$subexpression$2', 'symbols': ['cross_up_part_1$subexpression$2$string$2']},
      {'name': 'cross_up_part_1$subexpression$2$string$3', 'symbols': [{'literal':'o'}, {'literal':'v'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_up_part_1$subexpression$2', 'symbols': ['cross_up_part_1$subexpression$2$string$3']},
      {'name': 'cross_up_part_1$subexpression$2$string$4', 'symbols': [{'literal':'h'}, {'literal':'i'}, {'literal':'g'}, {'literal':'h'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_up_part_1$subexpression$2', 'symbols': ['cross_up_part_1$subexpression$2$string$4']},
      {'name': 'cross_up_part_1', 'symbols': ['cross_up_part_1$subexpression$1', '_', 'cross_up_part_1$subexpression$2'], 'postprocess':
        function(data) {
          return {
            kind: 'cross_up_part_1',
            data: data
          }
        }
      },
      {'name': 'cross_up_part_2$string$1', 'symbols': [{'literal':'r'}, {'literal':'i'}, {'literal':'s'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_up_part_2$ebnf$1', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'cross_up_part_2$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'cross_up_part_2', 'symbols': ['cross_up_part_2$string$1', 'cross_up_part_2$ebnf$1'], 'postprocess':
        function(data) {
          return {
            kind: 'cross_up_part_2',
            data: data
          }
        }
      },
      {'name': 'cross_down$ebnf$1$subexpression$1', 'symbols': ['synonyms_of_is', '__']},
      {'name': 'cross_down$ebnf$1', 'symbols': ['cross_down$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'cross_down$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'cross_down$subexpression$1', 'symbols': ['cross_down_part_1']},
      {'name': 'cross_down$subexpression$1', 'symbols': ['cross_down_part_2']},
      {'name': 'cross_down', 'symbols': ['cross_down$ebnf$1', 'cross_down$subexpression$1'], 'postprocess':
        function(data) {
          return {
            kind: 'cross_down',
            data: data
          }
        }
      },
      {'name': 'cross_down_part_1$subexpression$1$string$1', 'symbols': [{'literal':'c'}, {'literal':'r'}, {'literal':'o'}, {'literal':'s'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_down_part_1$subexpression$1$ebnf$1$subexpression$1$string$1', 'symbols': [{'literal':'e'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_down_part_1$subexpression$1$ebnf$1$subexpression$1', 'symbols': ['cross_down_part_1$subexpression$1$ebnf$1$subexpression$1$string$1']},
      {'name': 'cross_down_part_1$subexpression$1$ebnf$1$subexpression$1$string$2', 'symbols': [{'literal':'e'}, {'literal':'d'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_down_part_1$subexpression$1$ebnf$1$subexpression$1', 'symbols': ['cross_down_part_1$subexpression$1$ebnf$1$subexpression$1$string$2']},
      {'name': 'cross_down_part_1$subexpression$1$ebnf$1', 'symbols': ['cross_down_part_1$subexpression$1$ebnf$1$subexpression$1'], 'postprocess': id},
      {'name': 'cross_down_part_1$subexpression$1$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'cross_down_part_1$subexpression$1', 'symbols': ['cross_down_part_1$subexpression$1$string$1', 'cross_down_part_1$subexpression$1$ebnf$1']},
      {'name': 'cross_down_part_1$subexpression$1$string$2', 'symbols': [{'literal':'g'}, {'literal':'o'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_down_part_1$subexpression$1$ebnf$2$string$1', 'symbols': [{'literal':'e'}, {'literal':'s'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_down_part_1$subexpression$1$ebnf$2', 'symbols': ['cross_down_part_1$subexpression$1$ebnf$2$string$1'], 'postprocess': id},
      {'name': 'cross_down_part_1$subexpression$1$ebnf$2', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'cross_down_part_1$subexpression$1', 'symbols': ['cross_down_part_1$subexpression$1$string$2', 'cross_down_part_1$subexpression$1$ebnf$2']},
      {'name': 'cross_down_part_1$subexpression$1$string$3', 'symbols': [{'literal':'m'}, {'literal':'o'}, {'literal':'v'}, {'literal':'e'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_down_part_1$subexpression$1$ebnf$3', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'cross_down_part_1$subexpression$1$ebnf$3', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'cross_down_part_1$subexpression$1', 'symbols': ['cross_down_part_1$subexpression$1$string$3', 'cross_down_part_1$subexpression$1$ebnf$3']},
      {'name': 'cross_down_part_1$subexpression$1$string$4', 'symbols': [{'literal':'d'}, {'literal':'r'}, {'literal':'o'}, {'literal':'p'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_down_part_1$subexpression$1$ebnf$4', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'cross_down_part_1$subexpression$1$ebnf$4', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'cross_down_part_1$subexpression$1', 'symbols': ['cross_down_part_1$subexpression$1$string$4', 'cross_down_part_1$subexpression$1$ebnf$4']},
      {'name': 'cross_down_part_1$subexpression$2$string$1', 'symbols': [{'literal':'b'}, {'literal':'e'}, {'literal':'l'}, {'literal':'o'}, {'literal':'w'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_down_part_1$subexpression$2', 'symbols': ['cross_down_part_1$subexpression$2$string$1']},
      {'name': 'cross_down_part_1$subexpression$2$string$2', 'symbols': [{'literal':'d'}, {'literal':'o'}, {'literal':'w'}, {'literal':'n'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_down_part_1$subexpression$2', 'symbols': ['cross_down_part_1$subexpression$2$string$2']},
      {'name': 'cross_down_part_1$subexpression$2$string$3', 'symbols': [{'literal':'u'}, {'literal':'n'}, {'literal':'d'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_down_part_1$subexpression$2', 'symbols': ['cross_down_part_1$subexpression$2$string$3']},
      {'name': 'cross_down_part_1$subexpression$2$string$4', 'symbols': [{'literal':'l'}, {'literal':'o'}, {'literal':'w'}, {'literal':'e'}, {'literal':'r'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_down_part_1$subexpression$2', 'symbols': ['cross_down_part_1$subexpression$2$string$4']},
      {'name': 'cross_down_part_1', 'symbols': ['cross_down_part_1$subexpression$1', '_', 'cross_down_part_1$subexpression$2'], 'postprocess':
        function(data) {
          return {
            kind: 'cross_down_part_1',
            data: data
          }
        }
      },
      {'name': 'cross_down_part_2$string$1', 'symbols': [{'literal':'d'}, {'literal':'r'}, {'literal':'o'}, {'literal':'p'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'cross_down_part_2$ebnf$1', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'cross_down_part_2$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'cross_down_part_2', 'symbols': ['cross_down_part_2$string$1', 'cross_down_part_2$ebnf$1'], 'postprocess':
        function(data) {
          return {
            kind: 'cross_down_part_2',
            data: data
          }
        }
      },
      {'name': 'number$ebnf$1', 'symbols': [{'literal':'$'}], 'postprocess': id},
      {'name': 'number$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'number', 'symbols': ['number$ebnf$1', 'decimal_with_empty_parts'], 'postprocess':
        function(data) {
          return {
            kind: 'number',
            data: data
          }
        }
      },
      {'name': 'num_days$subexpression$1', 'symbols': ['number_words']},
      {'name': 'num_days$subexpression$1', 'symbols': ['int']},
      {'name': 'num_days', 'symbols': ['num_days$subexpression$1', '_', 'num_days_day_part'], 'postprocess':
        function(data) {
          return {
            kind: 'num_days',
            data: data
          }
        }
      },
      {'name': 'num_days_day_part$subexpression$1$string$1', 'symbols': [{'literal':'d'}, {'literal':'a'}, {'literal':'y'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'num_days_day_part$subexpression$1$ebnf$1', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'num_days_day_part$subexpression$1$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'num_days_day_part$subexpression$1', 'symbols': ['num_days_day_part$subexpression$1$string$1', 'num_days_day_part$subexpression$1$ebnf$1']},
      {'name': 'num_days_day_part$subexpression$1$string$2', 'symbols': [{'literal':'w'}, {'literal':'e'}, {'literal':'e'}, {'literal':'k'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'num_days_day_part$subexpression$1$ebnf$2', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'num_days_day_part$subexpression$1$ebnf$2', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'num_days_day_part$subexpression$1', 'symbols': ['num_days_day_part$subexpression$1$string$2', 'num_days_day_part$subexpression$1$ebnf$2']},
      {'name': 'num_days_day_part$subexpression$1$string$3', 'symbols': [{'literal':'m'}, {'literal':'o'}, {'literal':'n'}, {'literal':'t'}, {'literal':'h'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'num_days_day_part$subexpression$1$ebnf$3', 'symbols': [{'literal':'s'}], 'postprocess': id},
      {'name': 'num_days_day_part$subexpression$1$ebnf$3', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'num_days_day_part$subexpression$1', 'symbols': ['num_days_day_part$subexpression$1$string$3', 'num_days_day_part$subexpression$1$ebnf$3']},
      {'name': 'num_days_day_part', 'symbols': ['num_days_day_part$subexpression$1'], 'postprocess':
        function(data) {
          return {
            kind: 'num_days_day_part',
            data: data
          }
        }
      },
      {'name': 'ago$string$1', 'symbols': [{'literal':'a'}, {'literal':'g'}, {'literal':'o'}], 'postprocess': function joiner(d) {
        return d.join('')
      }},
      {'name': 'ago', 'symbols': ['ago$string$1'], 'postprocess':
        function(data) {
          return {
            kind: 'ago',
            data: data
          }
        }
      },
      {'name': 'symbol$ebnf$1', 'symbols': [/[a-z.$]/]},
      {'name': 'symbol$ebnf$1', 'symbols': ['symbol$ebnf$1', /[a-z.$]/], 'postprocess': function arrpush(d) {
        return d[0].concat([d[1]])
      }},
      {'name': 'symbol', 'symbols': ['symbol$ebnf$1'], 'postprocess':
        function(data, l, reject) {
          var res = isSymbol(data[0].join(''))
          if (!res) {
            return reject
          }
          return {
            kind: 'symbol',
            data: data,
            name: data[0]
          }
        }
      },
      {'name': 'unsigled_decimal_with_empty_parts', 'symbols': ['unsigned_int']},
      {'name': 'unsigled_decimal_with_empty_parts', 'symbols': ['unsigned_int', {'literal':'.'}]},
      {'name': 'unsigled_decimal_with_empty_parts', 'symbols': [{'literal':'.'}, 'unsigned_int']},
      {'name': 'unsigled_decimal_with_empty_parts', 'symbols': ['unsigned_int', {'literal':'.'}, 'unsigned_int'], 'postprocess':
        function(d) {
          return parseFloat(d[0] + (d[1] || '') + (d[2] || ''))
        }
      },
      {'name': 'decimal_with_empty_parts$ebnf$1', 'symbols': [{'literal':'-'}], 'postprocess': id},
      {'name': 'decimal_with_empty_parts$ebnf$1', 'symbols': [], 'postprocess': function(d) {
        return null
      }},
      {'name': 'decimal_with_empty_parts', 'symbols': ['decimal_with_empty_parts$ebnf$1', 'unsigled_decimal_with_empty_parts'], 'postprocess':
        function(d) {
          return d[0] === '-' ? -d[1] : d[0]
        }
      },
      {'name': 'percentage_with_empty_parts', 'symbols': ['decimal_with_empty_parts', {'literal':'%'}], 'postprocess':
        function(d) {
          return d[0] / 100
        }
      },
      {'name': '_$ebnf$1', 'symbols': []},
      {'name': '_$ebnf$1', 'symbols': ['_$ebnf$1', 'wschar'], 'postprocess': function arrpush(d) {
        return d[0].concat([d[1]])
      }},
      {'name': '_', 'symbols': ['_$ebnf$1'], 'postprocess': function(d) {
        return null
      }},
      {'name': '__$ebnf$1', 'symbols': ['wschar']},
      {'name': '__$ebnf$1', 'symbols': ['__$ebnf$1', 'wschar'], 'postprocess': function arrpush(d) {
        return d[0].concat([d[1]])
      }},
      {'name': '__', 'symbols': ['__$ebnf$1'], 'postprocess': function(d) {
        return null
      }},
      {'name': 'wschar', 'symbols': [/[ \t\n\v\f\u200b\u200c\u200d]/], 'postprocess': id}
    ]
    , ParserStart: 'grammar'
  })
  if (typeof module !== 'undefined'&& typeof module.exports !== 'undefined') {
    module.exports = grammar
  } else {
    window.grammar = grammar
  }
})()
